module.exports = __webpack_public_path__ + "static/media/loginLogo-375.8f5e3ecd.png";